/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gespraechsfuehrungchancenwerk2Inputs */

const de__field_gespraechsfuehrungchancenwerk2 = /** @type {(inputs: _Field_Gespraechsfuehrungchancenwerk2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprächsführung`)
};

/**

* @param {_Field_Gespraechsfuehrungchancenwerk2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_gespraechsfuehrungchancenwerk2 = /** @type {((inputs?: _Field_Gespraechsfuehrungchancenwerk2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gespraechsfuehrungchancenwerk2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_gespraechsfuehrungchancenwerk2(inputs)
});
export { _field_gespraechsfuehrungchancenwerk2 as "_field_gespraechsfuehrungChancenWerk" }